import React from 'react';

import { cn } from '../../lib/utils';

// Small colored status tag (e.g. VERIFIED, PRIMARY) used in the profile modal's
// cards. 10px semibold white on a solid fill, 4px radius.
const VARIANT_CLASS = {
  blue: 'bg-idle-blue',
  green: 'bg-green-500',
};

const StatusTag = ({ variant = 'blue', className, children }) => {
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded px-2 py-[2px] text-[10px] leading-[18px] font-semibold text-white',
        VARIANT_CLASS[variant],
        className,
      )}
    >
      {children}
    </span>
  );
};

export default StatusTag;
